import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey.js';

export const channelInfoAtom = atom<ChannelInfoObj>({
    key: RecoilAtomKey.channelInfoKey,
    default: {
        app_id: "",
        app_name: "",
        app_type: "",
        client_id: "",
        client_secret: "",
        company_id: "",
        company_name: "",
        config_id: "",
        is_active: false,
        tech_provider: "",
        wa_messaging_product: "",
        wa_phone_number: "",
        wa_phone_number_id: "",
        wa_recipient_type: "",
        wa_version: "",
        waba_id: "",
    },
});
